var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6699 2.17133C10.8651 1.97607 11.1817 1.97607 11.377 2.17133L13.877 4.67133C14.0723 4.86659 14.0723 5.18318 13.877 5.37844L6.127 13.1284C6.06073 13.1947 5.97718 13.241 5.88587 13.2621L2.63588 14.0121C2.4679 14.0508 2.2918 14.0003 2.16989 13.8784C2.04799 13.7565 1.99749 13.5804 2.03625 13.4124L2.78625 10.1625C2.80732 10.0711 2.85363 9.98759 2.91989 9.92133L10.6699 2.17133ZM3.7284 10.527L3.19053 12.8578L5.52129 12.3199L12.4613 5.37991C12.6574 5.18384 12.6574 4.86593 12.4613 4.66986L11.3785 3.58702C11.1824 3.39094 10.8645 3.39094 10.6684 3.58702L3.7284 10.527Z",
    fill: "#0A544F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14896 4.15041C9.31633 3.98305 9.58769 3.98305 9.75505 4.15041L11.8979 6.29327C12.0653 6.46064 12.0653 6.73199 11.8979 6.89936C11.7305 7.06673 11.4592 7.06673 11.2918 6.89936L9.14896 4.7565C8.9816 4.58914 8.9816 4.31778 9.14896 4.15041Z",
    fill: "#0A544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.f2396f9428f99a37284334e8e5bcc782.svg";
export { ForwardRef as ReactComponent };